import { Stack } from '@mantine/core';
import type { IObservableArray } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Campaign, Targeting } from '@feathr/blackbox';
import { CardV2 as Card, Checkbox } from '@feathr/components';

import * as styles from './AgeDemographics.css';

interface IProps {
  campaign: Campaign;
  targetings: IObservableArray<Targeting>;
}

function AgeDemographics({}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  // TODO: pull actual age demographics from the backend
  return (
    <Card width={'full'}>
      <Card.Header title={t('Age Demographics')} />
      <Card.Content addVerticalGap={false} contentClassName={styles.root}>
        <Checkbox
          label={
            <Stack gap={0}>
              18-24 years
              <span className={styles.description}>Young adults, college students</span>
            </Stack>
          }
          layout={'well'}
          name={'ageDemographics'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              25-34 years
              <span className={styles.description}>Young professionals, new families</span>
            </Stack>
          }
          layout={'well'}
          name={'ageDemographics'}
          value={true}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              35-44 years
              <span className={styles.description}>Established careers, growing families</span>
            </Stack>
          }
          layout={'well'}
          name={'ageDemographics'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              45-54 years
              <span className={styles.description}>Peak earning years, community leaders</span>
            </Stack>
          }
          layout={'well'}
          name={'ageDemographics'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              55-64 years
              <span className={styles.description}>Pre-retirement, established donors</span>
            </Stack>
          }
          layout={'well'}
          name={'ageDemographics'}
        />
        <Checkbox
          label={
            <Stack gap={0}>
              65+ years
              <span className={styles.description}>Retirees, legacy supporters</span>
            </Stack>
          }
          layout={'well'}
          name={'ageDemographics'}
        />
      </Card.Content>
    </Card>
  );
}

export default observer(AgeDemographics);
